/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "4358e6aabce49a0ccd3c63405c6c7385150b77ca";
